import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { CategoryMasterSection } from '@/widgets/category-master';
import { EditAreaTemplateMasterSection } from '@/widgets/edit-area-template-master';
import { FontMasterSection } from '@/widgets/font-master';
import { InkColorMasterSection } from '@/widgets/ink-color-master';
import { PrintMethodMasterSection } from '@/widgets/print-method-master';

/** 기준 정보 관리 — 카테고리 순서·인쇄 방식, 고객 에디터의 폰트·잉크 색상 목록 관리. (와이어프레임 #37) */
export const MasterDataPage = (): ReactElement => (
  <>
    <PageHeader
      title="기준 정보 관리"
      description="카테고리 순서·편집영역 템플릿·인쇄 방식·에디터 폰트·잉크 색상 관리"
    />

    <div className="flex flex-col gap-6">
      <CategoryMasterSection />
      <EditAreaTemplateMasterSection />
      <PrintMethodMasterSection />
      <FontMasterSection />
      <InkColorMasterSection />
    </div>
  </>
);
